<template>
  <div>
    <div class="head">
      <el-button type="primary" @click="handleInfoAdd" size="small"
        >添加保险公司</el-button
      >
    </div>
    <el-dialog
      title="编辑信息"
      :destroy-on-close="true"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="info" ref="form" :rules="formRules">
        <el-form-item label="代号" prop="keyword">
          <el-input v-model="info.keyword" />
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="info.name" />
        </el-form-item>
        <el-form-item label="全称" prop="fullname">
          <el-input v-model="info.fullname" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitForm">确 定</el-button>
      </div>
    </el-dialog>
    <el-table :data="dataList" v-loading="loading">
      <el-table-column prop="id" label="ID" />
      <el-table-column prop="keyword" label="代号" />
      <el-table-column prop="name" label="简称" />
      <el-table-column prop="fullname" label="全称" />
      <el-table-column label="操作">
        <template slot-scope="s">
          <el-button size="small" @click="handleInfoEdit(s.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pager
      ref="pager"
      api="company_list"
      model="product"
      @data-changed="handleDataChange"
    />
  </div>
</template>
<script>
import Pager from "../ui/Pager";
import request from "../../api/request";
export default {
  name: "CompanyList",
  components: { Pager },
  data: function() {
    return {
      dialogFormVisible: false,
      loading: false,
      dataList: [],
      info: {
        keyword: "",
        name: "",
        fullname: ""
      },
      formRules: {
        keyword: [
          { required: true, message: "不能为空" },
          {
            validator: (rule, value, callback) => {
              if (/[a-z]{3,10}/.test(value)) {
                callback();
              } else {
                callback(new Error("只能是3-10个小写字母"));
              }
            },
            trigger: "blur"
          }
        ],
        name: [{ required: true, message: "不能为空" }],
        fullname: [{ required: true, message: "不能为空" }]
      }
    };
  },
  methods: {
    handleDataChange(data) {
      this.dataList = data;
    },
    handleInfoEdit(info) {
      this.info = info;
      this.dialogFormVisible = true;
    },
    handleInfoAdd() {
      this.info = {};
      this.dialogFormVisible = true;
    },
    handleSubmitForm() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          await request.product.post("company_create", {
            name: this.info.name,
            fullname: this.info.fullname,
            keyword: this.info.keyword
          });
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.dialogFormVisible = false;
          this.$refs.pager.loadData()
        } else {
          this.$message({
            message: "信息填写错误",
            type: "error"
          });
        }
      });
    }
  }
};
</script>
